import React from "react";
import { observer } from "mobx-react";
import { BetDetailsBetCancelButton, BetDetailsBetReuseButton } from "../common";

import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import { Bet } from "@models";

import {
	DateCreated,
	Description,
	MaxCoefficient,
	MaxGain,
	NumberOfBets,
	NumberOfEvents,
	Payment,
	StakePerBet,
	TotalStake,
	HandlingFeePercentage,
	GainBonusPercentage,
	GainTaxPercentage,
	Gain,
	Payout,
} from "./details-components";
import { BetSlipReceiptModalStore } from "@state/stores/my-bets/BetSlipReceiptModalStore";

export const BetDetailsModalDetails = observer(
	function BetDetailsModalDetails(props: {
		isActive: boolean;
		store: BetDetailsModalStore | BetSlipReceiptModalStore;
		betSlip: Bet;
	}) {
		const { betSlip } = props;

		if (!props.isActive) {
			return null;
		}

		return (
			<>
				<div className="bet__details">
					<DateCreated bet={betSlip} />
					<Description bet={betSlip} />
					<NumberOfEvents bet={betSlip} />
					<NumberOfBets bet={betSlip} />
					<StakePerBet bet={betSlip} />
					<TotalStake bet={betSlip} />
					<HandlingFeePercentage bet={betSlip} />
					<MaxCoefficient bet={betSlip} />
					<GainBonusPercentage bet={betSlip} />
					<GainTaxPercentage bet={betSlip} />
					<MaxGain bet={betSlip} />
					<Payment bet={betSlip} />
					<Gain bet={betSlip} />
					<Payout bet={betSlip} />
				</div>
				{!props.store.isBetCancelOpen &&
					!props.store.isAutoSellOpen &&
					!props.store.isCashoutOpen && (
						<>
							<BetDetailsBetCancelButton
								store={props.store}
								bet={props.betSlip}
							/>
							<BetDetailsBetReuseButton
								store={props.store}
								bet={props.betSlip}
							/>
						</>
					)}
			</>
		);
	}
);
